import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const ListColorModal = ({
    isOpen,
    onClose,
    listName,
    setListName,
    availableColors,
    selectedColor,
    setSelectedColor,
    onSubmit,
    isEdit,
}) => (
    <AnimatePresence>
        {isOpen && (
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50"
            >
                <motion.div
                    initial={{ scale: 0.9 }}
                    animate={{ scale: 1 }}
                    exit={{ scale: 0.9 }}
                    className="bg-surface w-full max-w-md rounded-2xl shadow-2xl p-6 border border-line"
                >
                    <h3 className="text-lg font-semibold text-ink mb-4">
                        {isEdit ? "Edit List" : "Create New List"}
                    </h3>
                    <label className="block text-sm font-medium text-ink-secondary mb-1">
                        List Name
                    </label>
                    <input
                        type="text"
                        value={listName}
                        onChange={(e) => setListName(e.target.value)}
                        placeholder="Enter list name"
                        className="w-full border border-line rounded-lg px-3 py-2 text-sm mb-4 bg-surface-2 text-ink focus:outline-none focus:ring-1 focus:ring-primary"
                    />
                    <label className="block text-sm font-medium text-ink-secondary mb-2">
                        Choose a color
                    </label>
                    <div className="flex items-center gap-3 mb-6">
                        {availableColors.map((color) => (
                            <button
                                key={color}
                                type="button"
                                onClick={() => setSelectedColor(color)}
                                className={`w-8 h-8 rounded-full border transition ${
                                    selectedColor === color
                                        ? "ring-2 ring-offset-2 ring-primary ring-offset-surface"
                                        : "hover:ring-2 hover:ring-offset-1"
                                }`}
                                style={{ backgroundColor: color }}
                            />
                        ))}
                        <input
                            type="color"
                            className="w-8 h-8 rounded-full border border-line p-0 cursor-pointer"
                            title="Custom Color"
                            onChange={(e) => setSelectedColor(e.target.value)}
                        />
                    </div>
                    <div className="flex justify-end gap-3">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 text-sm bg-surface-2 text-ink-secondary rounded-lg hover:bg-surface-3"
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            onClick={onSubmit}
                            className="px-4 py-2 text-sm bg-primary text-primary-contrast rounded-lg hover:bg-primary-hover shadow-md"
                        >
                            {isEdit ? "Save" : "Create"}
                        </button>
                    </div>
                </motion.div>
            </motion.div>
        )}
    </AnimatePresence>
);

export default ListColorModal;
